import React, { useState } from "react";
import { Container, Row, Col, Navbar, Nav } from 'react-bootstrap';
import '../App.css';
import './Header.css';
import logo from '../assets/logo_png_para_web.png';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = menuOpen ? 300 : 100; // Altura del header sticky
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth", // Desplazamiento suave
      });
    }
  };

  return (
      <header className="header">
          <Container>
              <Row>                  
                  <Col xs={7} md={8} lg={3} className="text-start">
                      <a    href="#hero-section" // Proporciona un fallback para navegadores sin JavaScript
                            onClick={(e) => {
                            e.preventDefault(); // Evita el comportamiento predeterminado del enlace
                            scrollToSection("hero-section"); // Llama a la función de scroll
                        }}>
                          <img src={logo} alt="Data Dos" className="logo img-fluid" />
                      </a>
                  </Col>

                  <Col xs={5} md={4} lg={9} className="text-left">
                      <Navbar expand="lg" className="justify-content-end">
                          <Navbar.Toggle
                              aria-controls="navbar-nav"
                              className={`custom-toggler ${menuOpen ? "open" : ""}`}
                              onClick={toggleMenu}
                          />
                          <Navbar.Collapse id="navbar-nav">
                            <Nav as="ul" className="ms-auto font-inter fs-6">
                                <Nav.Item as="li">
                                <Nav.Link onClick={() => scrollToSection("hero-section")}>Inicio</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                <Nav.Link href="https://julianmarquezprogramador.es" target="_blank">Sobre mí</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                <Nav.Link onClick={() => scrollToSection("services-section")}>Lo que vas a recibir</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                <Nav.Link onClick={() => scrollToSection("explore-section")}>Casos de éxito</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                <Nav.Link onClick={() => scrollToSection("contact-section")}>Contacto</Nav.Link>
                                </Nav.Item>
                            </Nav>
                          </Navbar.Collapse>
                      </Navbar>                      
                  </Col>
              </Row>
          </Container>         
      </header>
  );
};

export default Header;
